import request from '@/common/http/request'

// 获取分享信息
export function getMemberExtend(data) {
    return request({
        url: '/memberExtend/info',
        method: 'post',
        data
    })
}

// 主动获取宝箱
export function getExtendAward(data) {
    return request({
        url: '/member/memberGetExtendAward',
        method: 'post',
        data
    })
}
